// Archive row protection is independent of storage-orphan retention.
export const ARCHIVE_RETENTION_DAYS = 30;
const DAY_MS = 24 * 60 * 60 * 1000;

export const ARCHIVE_RETENTION_HELPER = `Archived ads are kept for ${ARCHIVE_RETENTION_DAYS} days and can be restored any time before then.`;
export const ARCHIVE_EMPTY_COPY = `Nothing archived yet. Archived ads are kept for ${ARCHIVE_RETENTION_DAYS} days.`;

export function archiveRetention(
  archivedAt: Date | string,
  isSaved: boolean,
  isWinner: boolean,
  now = Date.now(),
) {
  const archivedMs = new Date(archivedAt).getTime();
  if (!Number.isFinite(archivedMs)) return null;
  // Use elapsed 24-hour days, not local calendar days, including across DST.
  const deadlineMs = archivedMs + ARCHIVE_RETENTION_DAYS * DAY_MS;
  const remainingMs = deadlineMs - now;
  return {
    daysAgo: Math.max(0, Math.floor((now - archivedMs) / DAY_MS)),
    deadline: new Date(deadlineMs),
    warning: remainingMs < 3 * DAY_MS,
    // Existing cleanup sweeps retain saved and winner rows even after expiry.
    kept: remainingMs <= 0 && (isSaved || isWinner),
  };
}
